import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ReactLoader from "react-loader-spinner";
import Translated from "../../../components/Translated/Translated";

function DialogEmailQuote(props) {
	const [open, setOpen] = React.useState(false);
	const [response, setResponse] = React.useState({});
	const [fileType, setFileType] = React.useState("");
	const [loading, setLoading] = React.useState(false);

	async function handleClose(inputFileType) {
		setFileType(inputFileType);
		setOpen(false);
	}

	async function handleClickOpen() {
		setResponse({});
		setOpen(true);
	}

	async function submit() {
		setLoading(true);
		let ajaxURL = props.APIUrl + "/emco_quotes/email-quote";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId,
			language: props.language,
			type: fileType
		};
		let APIResponse = await Axios.post(ajaxURL, data);
		setResponse(APIResponse.data);
		setLoading(false);
		return;
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="quote-dialog-info">
					<div><Translated section="Misc" label="send_email_dialog_message" /></div>
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="quote-nav-component">
			<input type="radio" name="quote-nav-radio" id="email-quote-toggle" />
			<label class="quote-nav-top-link" for="email-quote-toggle">
				<div class="quote-dialog-arrow">&#9664;</div>
				<div><Translated section="Quote" label="sub_nav_quote" /></div>
			</label>

			<div class="quote-nav-sidedrop">
				<button
					onClick={e => {
						handleClickOpen("word");
						setFileType("word");
					}}
					class="quote-nav-sub-link"
				>
					Word
				</button>
				<button
					onClick={e => {
						handleClickOpen("excel");
						setFileType("excel");
					}}
					class="quote-nav-sub-link"
				>
					Excel
				</button>
			</div>
			<Dialog open={open} onClose={handleClose}>
				{loading === true ? (
					<Dialog open={true} aria-labelledby="form-dialog-title">
						<DialogTitle id="form-dialog-title set-price-dialog-header">
							<Translated section="Misc" label="loading_label" />{" "}
						</DialogTitle>
						<DialogContent style={{ paddingRight: "10em" }}>
							<ReactLoader
								style={{ marginLeft: "8em" }}
								type="Oval"
								color="#00BFFF"
								height={50}
								width={50}
							/>
						</DialogContent>
					</Dialog>
				) : (
					<div class="quote-dialog">
						<div class="quote-dialog-title"><Translated section="Misc" label="send_email_dialog_title" /></div>

						{hasResponse ? responseBody() : formBody()}

						<div class="quote-dialog-footer">
							<button class="quote-dialog-button" onClick={handleClose}>
								{hasResponse 
									? <Translated section="Misc" label="close_btn" />
									: <Translated section="Misc" label="no_btn" />
								}
							</button>
							{hasResponse ? (
								""
							) : (
								<button class="quote-dialog-button" onClick={submit}>
									<Translated section="Misc" label="yes_btn" />
								</button>
							)}
						</div>
					</div>
				)}
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DialogEmailQuote);
